import React from "react";

import { CKEditor } from "../editor/ckeditor/CKEditor";
import { TextToSpeechPlayer } from "../editor/texttospeech/TextToSpeechPlayer";
import { useOfflineAssets } from "../../offline/useOfflineAssets";
import { AppBar, Paper, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
	editorToolBar: {
		position: "absolute",
		top: 70,
		zIndex: theme.zIndex.drawer + 1,
	},
	builder: {
		position: "absolute",
		right: 0,
		left: 0,
		top: 110,
		bottom: 0,
		overflowY: "hidden",
	},
	content: {
		flexGrow: 1,
		paddingRight: theme.spacing(4),
		transition: theme.transitions.create("margin", {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.leavingScreen,
		}),
		marginRight: -48,
	},
	contentShift: {
		transition: theme.transitions.create("margin", {
			easing: theme.transitions.easing.easeOut,
			duration: theme.transitions.duration.enteringScreen,
		}),
		marginRight: 0,
	},
	editor: {
		height: "100%",
	},
}));

export interface Props {
	isMobileIconsDrawerOpen: boolean;
}

export function IOSBuilderView(props: Props) {
	const { onlineMode } = useOfflineAssets();
	const classes = useStyles();
	const [keyboardActive, setKeyboardActive] = React.useState(false);
	const [show, setShow] = React.useState(false);

	React.useEffect(() => {
		function onResize() {
			setKeyboardActive(!keyboardActive);
		}

		window.addEventListener("resize", onResize);
		let body = document.getElementsByTagName("body")[0];
		body.style.position = "fixed";
		body.style.overflow = "hidden";
		body.style.top = "0";
		body.style.bottom = "0";
		body.style.right = "0";
		body.style.left = "0";

		setShow(true);

		return () => {
			window.removeEventListener("resize", onResize);

			let body = document.getElementsByTagName("body")[0];
			body.style.position = "unset";
			body.style.overflow = "unset";
			body.style.top = "unset";
			body.style.bottom = "unset";
			body.style.right = "unset";
			body.style.left = "unset";
		};
	}, [keyboardActive]);

	// The body style must be updated before rendering
	if (!show) {
		return null;
	}

	return (
		<>
			<AppBar className={classes.editorToolBar}>
				<div className="ios-toolbar">
					<div id="toolbar-container" />
				</div>
			</AppBar>
			<Paper square className={classes.builder} onClick={() => setTimeout(() => window.scrollTo(0, 0), 150)} elevation={2}>
				<CKEditor
					className={classes.editor}
					onFocus={() => setKeyboardActive(true)}
					onBlur={() => setKeyboardActive(false)}
					style={{ paddingBottom: keyboardActive ? "10000px" : undefined, paddingRight: props.isMobileIconsDrawerOpen && onlineMode ? 60 : 28 }}
				/>
				<TextToSpeechPlayer />
			</Paper>
		</>
	);
}